export default __webpack_public_path__ + "static/media/mwide-sub-base.daaf5b7c.png";